import { type FC } from 'react';
import { View, XStack, YStack } from '@shinetools/sunshine-universal';

export interface OperationDetailsItemProps {
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const OperationDetailsItem: FC<OperationDetailsItemProps> = ({
  children,
  icon,
}) => {
  return (
    <XStack
      alignItems="center"
      borderBottomColor="transparent"
      borderLeftColor="$grey.200"
      borderRadius={8}
      borderRightColor="$grey.200"
      borderTopColor="$grey.200"
      borderWidth={2}
      gap={16}
      justifyContent="space-between"
      padding="$space.16"
    >
      {icon ? <View>{icon}</View> : null}

      <YStack flexDirection="column">{children}</YStack>

      <View />
    </XStack>
  );
};

export default OperationDetailsItem;
